import React, { useEffect } from 'react';
import { MinusCircleOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import ColorPickerField from '@components/common/form/ColorPickerField';
import FieldSet from '@components/common/form/FieldSet';
import useTranslate from '@hooks/useTranslate';
import { CheckboxField, NumericField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Button, Col, Flex, Form, Row } from 'antd';

import './index.scss';

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    colon: false,
};

const TableSettingForm = ({
    formId,
    settingObj,
    onSubmit,
    setIsChangedFormValues,
    isChangedFormValues,
    loadingUpdate,
}) => {
    const translate = useTranslate();
    const [ form ] = Form.useForm();

    const onValuesChange = () => {
        setIsChangedFormValues(true);
    };

    useEffect(() => {
        form.setFieldsValue(settingObj);
    }, [ settingObj, form ]);

    return (
        <Form
            id={formId}
            form={form}
            layout="horizontal"
            onFinish={onSubmit}
            initialValues={settingObj}
            onValuesChange={onValuesChange}
        >
            <FieldSet className="custom-fieldset mt-4" title={translate.formatMessage(commonMessage.option)}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Row>
                            <Col span={24}>
                                <TextField
                                    name={[ 'tableSetting', 'question' ]}
                                    placeholder={translate.formatMessage(commonMessage.placeholderQuestion)}
                                    label={translate.formatMessage(commonMessage.placeholderQuestion)}
                                />
                            </Col>
                            <Col span={24} className="ant-col ant-form-item-label" style={{ color: '#000000d9' }}>
                                {translate.formatMessage(commonMessage.options)}
                            </Col>
                            <Col span={24}>
                                <Form.List name={[ 'tableSetting', 'options' ]} label={translate.formatMessage(commonMessage.options)}>
                                    {(fields, { add, remove }) => {
                                        return (
                                            <div className="no-margin-form-item">
                                                {fields.map((field, index) => (
                                                    <Row gutter={[ 16, 16 ]} key={field.key} style={{ marginBottom: 8 }}>
                                                        <Col flex="auto">
                                                            <TextField
                                                                name={[ field.name, 'value' ]}
                                                                required
                                                                style={{ width: '100%' }}
                                                                placeholder=""
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <TextField
                                                                name={[ field.name, 'symbol' ]}
                                                                style={{ width: '80px' }}
                                                                placeholder=""
                                                                className="symbol-input"
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <ColorPickerField
                                                                name={[ field.name, 'color' ]}
                                                                dataForm={settingObj?.tableSetting?.options}
                                                                style={{ width: '80px' }}
                                                                enableAlpha={false}
                                                            />
                                                        </Col>
                                                        <Col flex="none">
                                                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                                                        </Col>
                                                    </Row>
                                                ))}

                                                <Form.Item style={{ width: '170px' }}>
                                                    <Button type="dashed" onClick={() => add()} block>
                                                        <PlusOutlined />
                                                        {translate.formatMessage(commonMessage.addOption)}
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                </Form.List>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </FieldSet>

            <FieldSet className="custom-fieldset mt-4" title={translate.formatMessage(commonMessage.settings)}>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            name={[ 'tableSetting', 'footer_message' ]}
                            placeholder={translate.formatMessage(commonMessage.placeholderFooterMessage)}
                            label={translate.formatMessage(commonMessage.placeholderFooterMessage)}
                        />
                    </Col>
                    <Col span={12}>
                        <NumericField
                            formatter={(v) => v}
                            parser={(v) => v}
                            name={[ 'tableSetting', 'time_wait_for_notify_order' ]}
                            placeholder={translate.formatMessage(commonMessage.placeholderTimeWaitNotify)}
                            label={translate.formatMessage(commonMessage.placeholderTimeWaitNotify)}
                            width="100%"
                            required
                        />
                    </Col>
                </Row>
            </FieldSet>
            <Flex justify="end">
                <Button
                    style={{ marginLeft: '10rem', marginTop: 12 }}
                    key="submit"
                    htmlType="submit"
                    type="primary"
                    disabled={!isChangedFormValues}
                    loading={loadingUpdate}
                >
                    <div>
                        <SaveOutlined style={{ marginRight: '6px' }} />
                        {translate.formatMessage(commonMessage.update)}
                    </div>
                </Button>
            </Flex>
        </Form>
    );
};

export default TableSettingForm;
